module.exports = __webpack_public_path__ + "static/media/service3.4d27e983.jpg";